// @flow

import React, { type Node } from 'react';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getCountry, getPaymentTypeCode, useIncomingPayment, isRetry } from '@tectonics/prs/incoming-payment';
import { getReceiptAmountLocalTotal } from '@tectonics/prs/receipts/receipt';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';
import { useCurrentReceipt } from '@tectonics/prs/receipts';

import { getMoneyFormat } from '../../commons/money-format';

export function Header(): Node {
  const allFeatures = useAllFeatures();

  return (
    <IfFeature allFeatures={allFeatures} wanted="display_receipt_final_amount">
      <DisplayTotalValue />
    </IfFeature>
  );
}

function DisplayTotalValue(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(country);
  const formatAmount = amountToCurrencyString(decimalFormat);

  switch (country) {
    case 'br':
      return <DisplayBrazilianTotalValue />;

    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'ar':
    case 'bo':
    case 'uy':
      return (
        <p>
          Ingresa la siguiente información para completar tu pago de
          <strong>&nbsp;{formatAmount(getReceiptAmountLocalTotal(receipt))}:</strong>
        </p>
      );
    default:
      throw new Error(`DisplayTotalValue: country not mapped: "${country}"`);
  }
}

function DisplayBrazilianTotalValue(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  const receipt = useCurrentReceipt();
  const decimalFormat = getMoneyFormat(country);
  const formatAmount = amountToCurrencyString(decimalFormat);

  if (getPaymentTypeCode(incomingPayment) === 'vr' && isRetry(incomingPayment)) {
    return (
      <p><strong>CVV inválido. Revise e tente novamente</strong></p>
    );
  }

  if (getPaymentTypeCode(incomingPayment) === 'vr') {
    return (
      <p>Para completar o pedido, confirme o código de segurança (CVV) de seu cartão.</p>
    );
  }

  return (
    <p>
      Preencha seus dados abaixo para finalizar sua compra no valor de
      <strong>&nbsp;{formatAmount(getReceiptAmountLocalTotal(receipt))}:</strong>
    </p>
  );
}
